module.exports = __webpack_public_path__ + "img/webtoon.0542613b.jpg";